
import Price from '~/components/Price';
export default {
  components: { Price },
  inheritAttrs: false,
  props: {
    offers: {
      type: Array,
      required: true,
    },
  },
};
